<template>
  <div class="orglist">
    <div class="campus">机构管理</div>
    <el-card :span="24">
      <div class="header">机构管理</div>
      <div class="content">
        <el-button type="primary" class="mb-24" @click="addOrg('form')">新建机构</el-button>
        <div class="search">
          <span>机构名称：</span>
          <el-input v-model="searchName" @keyup.13.native="getOrgList" placeholder="请输入机构名称"></el-input>
          <el-button type="primary" class="buttons" @click="getOrgList">查 询</el-button>
        </div>
        <div class="tableStyle">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="name" label="机构名称" max-width="360"></el-table-column>
            <el-table-column prop="orgcode" label="机构代码" min-width="50"></el-table-column>
            <el-table-column prop="showCreateTime" label="创建时间"></el-table-column>
            <el-table-column label="机构基本账号">
              <template slot-scope="scope">
                <el-button type="text" @click="lookOrg(scope.row.id)" class="chakan">查看</el-button>
                <!-- <el-dialog title="机构基本账号" :visible.sync="dialogTableVisible" width="600px">
                  <el-table :data="gridData" border class="qingkuang">
                    <el-table-column property="username" label="机构账号"></el-table-column>
                    <el-table-column property="creatorname" label="创建人"></el-table-column>
                    <el-table-column property="address" label="账号密码"></el-table-column>
                  </el-table>
                </el-dialog> -->
              </template>
            </el-table-column>
            <el-table-column label="账号状态">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.booleanStatus" active-color="#07C160" inactive-color="#E5E5E5"
                  @change="zhuangtai(scope.row.booleanStatus, scope.row.id)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="editOrg(scope.row)">编辑</el-button>
                <el-button type="text" @click="deletBookGroup(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="dz-flex dz-flex-justify-end mt-12">
          <el-pagination background @size-change="getOrgList" @current-change="getOrgList" :current-page.sync="page"
            :page-sizes="[10, 20, 30, 50, 100]" :page-size.sync="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <!-- 会话框 -->
    <div class="dialog">
      <!-- 新建,编辑机构 -->
      <el-dialog :title="dialogType ? '编辑机构分类':'新增机构分类'" :visible.sync="publicDialog" width="600px" center>
        <el-form ref="form" :model="form" :rules="FormRules" label-width="120px">
          <el-form-item label="机构名称:" prop="name">
            <el-input v-model="form.name" placeholder="请您输入机构名称 ( 不超过12字 )"></el-input>
          </el-form-item>
          <el-form-item label="机构代码:" prop="orgcode">
            <el-input v-model="form.orgcode" placeholder="请您输入机构代码"></el-input>
          </el-form-item>
          <el-form-item label="联系电话:" prop="tel">
            <el-input v-model="form.tel" placeholder="请您输入固定联系号码，以便联系"></el-input>
          </el-form-item>
          <el-form-item label="机构邮箱:" prop="email">
            <el-input v-model="form.email" placeholder="请您输入机构邮箱"></el-input>
          </el-form-item>
          <el-form-item label="机构地区:" prop="region">
            <el-cascader size="large" :options="options" v-model="form.region" @change="setRegion" placeholder="请选择您所在的城市" clearable>
            </el-cascader>
          </el-form-item>
          <el-form-item label="机构地址:" prop="address">
            <el-input class="mt-10" v-model="form.address" placeholder="您输入机构具体地址"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="publicDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitAdd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { $getOrgList, $newOrg, $updateOrg } from '@/api/organiza';
import { $debounce } from '@/utils/index';
import { regionData } from 'element-china-area-data';

const FormRules = {
  name: [
    {
      required: true,
      message: '请输入机构分类名称',
      trigger: ['blur', 'change'],
    },
  ],
  orgcode: [
    {
      required: true,
      message: '请输入机构代码',
      trigger: ['blur', 'change'],
    },
  ],
  tel: [
    {
      required: true,
      message: '请输入联系电话',
      trigger: ['blur', 'change'],
    },
  ],
  email: [
    {
      required: true,
      message: '请输入机构邮箱',
      trigger: ['blur', 'change'],
    },
  ],
  region: [
    {
      required: true,
      message: '请选择机构地区',
      trigger: ['blur', 'change'],
    },
  ],
  address: [
    {
      required: true,
      message: '请输入机构地址',
      trigger: ['blur', 'change'],
    },
  ],
};
export default {
  name: 'orglist',
  data() {
    return {
      // 省市县数据
      options: regionData,
      // 验证规则
      FormRules,
      // 筛选条件 和 表格数据
      searchName: '',
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      // 会话框数据
      publicDialog: false,
      dialogType: '',
      form: {
        region: [],
      },
    };
  },
  created() {
    this.$nextTick(() => {
      // 调用 查询机构列表
      this.getOrgList();
    });
  },
  methods: {
    // 查询机构列表
    async getOrgList() {
      // let data = {
      //   page: this.page,
      //   pageSize: this.pageSize,
      //   name: this.searchName,
      // };
      // const res = await $getOrgList(data);
      // if (res.data.code === 0) {
      //   this.tableData = res.data.data;
      //   this.total = res.data.size;
      // }

      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/org/selectOrgList',
        method: 'POST',
        data: {
          page: this.page,
          pageSize: this.pageSize,
          publisherid: this.id,
          orgid: 8,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.tableData = result.data.data;
          this.total = result.data.size;
        })
        .catch((err) => {
          return this.$message.error('查询失败！：' + err);
        });
    },
    // 新增机构分类
    addOrg(formName) {
      this.publicDialog = true;
      this.$nextTick(() => {
        this.form = {
          region: [],
        };
        this.$refs[formName].resetFields();
        this.dialogType = 0;
      });
    },
    // 编辑机构
    editOrg(row) {
      this.form = {
        id: row.id,
        name: row.name,
        orgcode: row.orgcode,
        tel: row.tel,
        email: row.email,
        address: row.address,
        region: [row.province, row.city, row.district],
        province: row.province,
        city: row.city,
        district: row.district,
      };
      this.dialogType = 1;
      this.publicDialog = true;
    },
    // 确认新增和编辑机构  新增dialogType:0 编辑dialogType:1
    submitAdd: $debounce(function () {
      this.$refs['form'].validate(async (valid) => {
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        // 如果表单验证失败，停止请求提交
        if (!valid) {
          this.$message.error('新增信息缺失！');
          return;
        } else {
          if (this.dialogType) {
            // 编辑机构分类
            // const res = await $updateOrg(this.form);
            // if (res.data.code === 0) {
            //   this.getOrgList();
            //   this.$message.success(res.data.message);
            // } else {
            //   this.$message.error(res.data.message);
            // }
            // this.publicDialog = false;

            let pro = this.$http({
              url: '/edu/org/updateEduOrg',
              method: 'POST',
              data: this.form,
              headers: {
                Authorization: 'Bearer ' + token,
              },
            });
            pro
              .then((result) => {
                if (result.data.code !== 0) {
                  this.publicDialog = false;
                  return this.$message.error(result.data.message);
                }
                this.getOrgList();
                this.$message.success(result.data.message);
                this.publicDialog = false;
              })
              .catch((err) => {
                return this.$message.error('编辑失败！：' + err);
              });
          } else {
            // 新增机构分类
            // const res = await $newOrg(this.form);
            // if (res.data.code === 0) {
            //   this.getOrgList();
            //   this.$message.success(res.data.message);
            // } else {
            //   this.$message.error(res.data.message);
            // }
            // this.publicDialog = false;

            let pro = this.$http({
              url: '/edu/org/addOrg',
              method: 'POST',
              data: this.form,
              headers: {
                Authorization: 'Bearer ' + token,
              },
            });
            pro
              .then((result) => {
                if (result.data.code !== 0) {
                  this.publicDialog = false;
                  return this.$message.error(result.data.message);
                }
                this.getOrgList();
                this.$message.success(result.data.message);
                this.publicDialog = false;
              })
              .catch((err) => {
                return this.$message.error('新建失败！：' + err);
              });
          }
        }
      });
    }, 500),
    // 查看
    lookOrg() {},
    // 地区选择
    setRegion(value) {
      this.form.province = value[0];
      this.form.city = value[1];
      this.form.district = value[2];
    },
  },
};
</script>

<style lang="less">
.orglist {
  .el-card__body {
    padding: 0 1.3vw;
  }
}
</style>